import React from 'react'
import { useTranslation } from 'react-i18next'
import useNavigationFunctions from '~/helper/navigationFunctions'
import useTutorialFunctions from '~/helper/tutorialFunctions'
import * as S from './styled'

export default function StripeTooltip({ closeProps, tooltipProps }) {
  const { t } = useTranslation()
  const { setCommunityCurrentTabAction } = useNavigationFunctions()
  const { setTutorialAsInativeAction } = useTutorialFunctions()

  const goToPackagesTab = () => {
    setCommunityCurrentTabAction('packages')
  }

  const goToSponsorsTab = () => {
    setCommunityCurrentTabAction('sponsors')
  }

  return (
    <S.ComponentContainer {...tooltipProps}>
      <S.TooltipArrow />
      <S.TooltipUserAvatar />
      <S.TooltipContainer>
        <S.CloseButtonContainer {...closeProps}>
          <S.CloseIcon onClick={() => setTutorialAsInativeAction()} />
        </S.CloseButtonContainer>
        <S.Title>{t('communityStep3TutorialTitle')}</S.Title>
        <S.Subtitle>{t('stripeTabTooltipSubtitle')}</S.Subtitle>
        <S.ButtonsContainer>
          <S.BackButton onClick={() => goToPackagesTab()}>
            <S.BackButtonText>{t('back')}</S.BackButtonText>
          </S.BackButton>
          <S.NextButton onClick={() => goToSponsorsTab()}>
            <S.NextButtonText>{t('next')}</S.NextButtonText>
          </S.NextButton>
        </S.ButtonsContainer>
      </S.TooltipContainer>
    </S.ComponentContainer>
  )
}
